import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { ProgressIndicator } from '../indicators/ProgressIndicator';
import { useLanguage} from "../../hooks/useLanguage";

export const ProgressBlock = (props) => {
  const { t } = useLanguage()

  return (
    <React.Fragment>
      <div className={'progress-indicator-container'}>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Box mx={2}>
              <ProgressIndicator number={1} label={t('journey_info_with_us')} value={props.value1} />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box mx={2}>
              <ProgressIndicator number={2} label={t('journey_info_safe_seven')} value={props.value2} />
            </Box>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
};

export default ProgressBlock;
